import { PlayCircleIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import React from 'react';
import { Card, CardMedia, CardContent, Typography, Box, IconButton } from '@mui/material';
import { Tutorial } from '@/types/tutorials';

interface VideoCardProps {
  tutorial: Tutorial;
}

const VideoCard: React.FC<VideoCardProps> = ({ tutorial }) => {
  return (
    <Card 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        boxShadow: 2,
        borderRadius: 2,
        overflow: 'hidden',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 4,
          cursor: 'pointer'
        }
      }}
      onClick={() => window.open(tutorial.youtubeUrl, '_blank')}
    >
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          height="200"
          image={tutorial.thumbnailUrl || "https://images.unsplash.com/photo-1611162617474-5b21e879e113?q=80&w=640&auto=format&fit=crop"} // Default placeholder just in case
          alt={tutorial.title}
          sx={{ objectFit: 'cover' }}
        />
        {/* Play Icon Overlay */}
        <Box 
          sx={{
            position: 'absolute',
            top: 0, left: 0, right: 0, bottom: 0,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            bgcolor: 'rgba(0,0,0,0.3)',
            opacity: 0,
            transition: 'opacity 0.3s',
            '&:hover': { opacity: 1 }
          }}
        >
          <IconButton sx={{ color: 'white' }}>
            <HugeiconsIcon icon={PlayCircleIcon} size={60} />
          </IconButton>
        </Box>
        
        {/* Duration Badge */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            bgcolor: 'rgba(0,0,0,0.7)',
            color: 'white',
            px: 1,
            borderRadius: 1,
            fontSize: '0.75rem',
            fontWeight: 'bold'
          }}
        >
          {tutorial.duration}
        </Box>
      </Box>

      <CardContent sx={{ p: 2, pb: '16px !important' }}>
        <Typography variant="subtitle1" fontWeight="bold" lineHeight={1.2}>
          {tutorial.title}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default VideoCard;
